import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import KpiDescription from './KpiDescription';
import KpiOverviewBtn from './KpiOverviewBtn';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appHelper from '../../../helpers/appHelper';
import * as kpiHelper from '../../../helpers/kpiHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as animationHelper from "../../../helpers/animationHelper";

class KpiOverview extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            lang: this.props.lang,
            status: objectConstants.STATUS_NOT_STARTED,
            userData: this.props.userData,
            screenObject: this.props.screenObject,
            bite_id: this.props.callbacks.getBiteId(),
            kpis: appHelper.getBiteById(this.props.callbacks.getBiteId()).performance_kpis,
            locale: appHelper.getLocalData(this.props.screenObject),
            activeKpi: {},
            activeKpiLocale: {},
            primaryKpi: {},
            secondaryKpis: [],
            objectCallbacks: {},
            completeObjects: [],
            guid: dataHelper.createGuid(),
            screenStatus: "",
            checkComplete: false,
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(), this.props.callbacks.getScreenId(), this.props.screenObject.asset_id),
            continue_label: appHelper.getLocaleString("continue_label")
        };

        this.setKpis = this.setKpis.bind(this);
        this.show = this.show.bind(this);
        this.setActiveKpi = this.setActiveKpi.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.onObjectComplete = this.onObjectComplete.bind(this);
        this.checkBtnComplete = this.checkBtnComplete.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.onProgressionBtnClicked = this.onProgressionBtnClicked.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);

        this.objectRef = React.createRef();
    }

    componentDidMount() {
        if (this.state.kpis.length > 0) {
            this.setCallbacks();
            this.setKpis(kpiHelper.getPrimaryKpi(this.state.kpis));
            this.show();
            this.getScreenStatus();
            if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
                this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
            }
        } else {
            this.onComplete();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                activeKpiLocale: Object.assign({}, appHelper.getLocalData(this.state.activeKpi)),
                continue_label: appHelper.getLocaleString("continue_label")
            });
        }
    }

    componentDidUpdate() {
        if (this.state.checkComplete) {
            this.onComplete();
        }

    }

    scrollToTop() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE && screenStatus !== objectConstants.STATUS_COMPLETE) {
            let object = this.refs[`kpi_overview`];
            let scrollTo = this.props.callbacks.scrollTo;
            setTimeout(function () {
                scrollTo(object.offsetTop, true);
            }, objectConstants.SCROLL_TO);
        }
    }

    setCallbacks() {
        this.setState({
            objectCallbacks: Object.assign({}, this.state.objectCallbacks,
                {
                    onObjectComplete: this.onObjectComplete
                }
            )
        });
    }

    getScreenStatus() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        this.setState({
            screenStatus: screenStatus,
            status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
        });
    }

    getObjectStatus() {
        if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
            this.setState({
                status: objectConstants.STATUS_COMPLETE,
                checkComplete: true
            });

        } else {
            let objectUserData = {};
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                let subScreenParent = this.props.callbacks.getSubScreenParent();
                let screen_id = this.props.callbacks.getScreenId();
                if (appHelper.isDefined(subScreenParent)) {
                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                } else {
                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }
            }

            if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
                this.setState({status: objectConstants.STATUS_COMPLETE, checkComplete: true});
            } else {
                this.setState({checkComplete: true});
            }

        }

    }

    setKpis() {
        this.setActiveKpi(this.state.kpis[0]);
    }

    setActiveKpi(kpi) {
        this.onObjectComplete(kpi);
        this.setState({
            activeKpi: Object.assign({}, kpi),
            activeKpiLocale: Object.assign({}, appHelper.getLocalData(kpi))
        });
    }


    onObjectComplete(kpi) {
        let index = appHelper.getArrayObjectIndexByKey(this.state.completeObjects, "kpi_id", kpi.kpi_id);
        if (index === -1) {
            this.setState(
                {
                    completeObjects: dataHelper.immutablePush(this.state.completeObjects, kpi),
                    status: objectConstants.STATUS_IN_PROGRESS
                }
            );
        }
    }

    onComplete() {
        this.setState({checkComplete: false});
        let hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
        if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
            if (!hasNextObject) {
                this.handleProgression();
                this.enableProgression();
            } else {
                this.enableProgression();
            }

        } else {

            this.handleProgression();
        }

        if(this.state.kpis.length === 0){
            this.enableProgression();
        }
        this.scrollToTop();
    }

    enableProgression() {
        if (!this.props.callbacks.isReviewMode()) {
            this.setState({showProgressionButton: true});
        }
    }

    handleProgression() {
        let progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
        let progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
        let progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
        let completionData = {
            progression: progressionRule,
            progressionType: progressionType,
            progressionGoToId: progressionGoToId,
            asset_id: this.state.screenObject.asset_id,
            status: objectConstants.STATUS_COMPLETE,
            asset_type_code: this.state.screenObject.asset_type_code,
            navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
            index: this.props.index
        };

        this.props.callbacks.onObjectComplete(completionData);
        //t

    }

    onProgressionBtnClicked() {
        this.setState({showProgressionButton: false});
        if (this.props.callbacks.hasNextObject(this.props.index)) {
            this.handleProgression();
        } else {
            this.props.callbacks.navigateToNextScreen();
        }
    }

    show() {
        let objectRef = this.objectRef.current;
        if(appHelper.isObjectEleDefined(objectRef)) {
            let params = {
                ele: objectRef,
                duration: objectConstants.SHOW_PANEL_DURATION,
                delay: 0,
                callback: this.getObjectStatus
            };
            animationHelper.showHeight(params);
        }
    }

    checkBtnComplete(kpi) {
        return this.state.status === objectConstants.STATUS_COMPLETE || (appHelper.getArrayObjectIndexByKey(this.state.completeObjects, "code", kpi.code) > -1);
    }

    render() {

        return (
            <div className="a-c" ref={this.objectRef}>
                {this.state.kpis.length > 0
                    ?

                    <div className="object-container">
                        {
                            this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null && this.state.locale.label.length > 0
                                ?
                                <h4 className={objectConstants.DEFAULT_HEADING_CLASS}
                                    dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                                :
                                null
                        }
                        {
                            appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                                ?
                                <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                :
                                null
                        }
                        <br/>

                        <div className="kpi-overview-panel">
                            {this.state.kpis.map(kpi =>
                                <KpiDescription key={kpi.kpi_id}
                                                kpi={kpi}
                                                bite_id={this.state.bite_id}
                                                callbacks={this.state.objectCallbacks}/>
                            )}
                        </div>

                        {this.state.showProgressionButton
                            ? <Button label={this.state.continue_label}
                                      id={`${this.state.screenObject}_button`}
                                      onClick={this.onProgressionBtnClicked}/>
                            : null
                        }
                    </div>
                    :
                    null
                }
            </div>
        );
    }
}

KpiOverview.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    index: PropTypes.number,
    userData: PropTypes.object,
    lang: PropTypes.string.isRequired,
    trackingData: PropTypes.object
};

KpiOverview.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        userData: state.userData,
        trackingData: state.trackingData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(KpiOverview);



/** WEBPACK FOOTER **
 ** ./src/components/objects/kpi/KpiOverview.js
 **/